import { alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

export const appScrollbarTrackColor = (theme: Theme): string => (
  alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.2 : 0.1)
);

export const appScrollbarThumbColor = (theme: Theme): string => (
  alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.4 : 0.3)
);

export const appScrollbarThumbHoverColor = (theme: Theme): string => (
  alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.52 : 0.42)
);

export const appScrollbarSx = {
  scrollbarWidth: "thin" as const,
  scrollbarColor: (theme: Theme) => `${appScrollbarThumbColor(theme)} ${appScrollbarTrackColor(theme)}`,
  "&::-webkit-scrollbar": {
    width: 10,
    height: 10,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: appScrollbarTrackColor,
    borderRadius: 999,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: appScrollbarThumbColor,
    borderRadius: 999,
    border: (theme: Theme) => `2px solid ${appScrollbarTrackColor(theme)}`,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: appScrollbarThumbHoverColor,
  },
};
